/**
 * Sabeang App Entry Point
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from '@kisoplan/shared/components';
import { ThemeProvider } from './contexts/ThemeContext';
import App from './App';
import './index.css';
import './styles/theme.css';

// Error boundary for the entire app
const AppWithErrorBoundary = () => (
  <ErrorBoundary
    onError={(error, errorInfo) => {
      console.error('[Sabeang] Unhandled error:', error, errorInfo);
      // TODO: Send to error reporting service
    }}
  >
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </ErrorBoundary>
);

// Render app
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppWithErrorBoundary />
  </React.StrictMode>
);
